import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Table, Button } from 'antd';
import { isValidArray } from 'src/Library/Helper';

const styles = theme => ({});

interface FailureTableRow {
  objectId: string;
  reasons: string;
  row_number: number;
}

class BulkTrackingErrorModal extends React.PureComponent<any, any> {

  state:any = {
    columnNameForTable: [],
  };

  componentDidMount() {
    this.setState({
      columnNameForTable: this.generateColumnForTable(),
    });
  }

  modifyFailureArray = (failureArray): FailureTableRow[] => {
    if (!failureArray || !Array.isArray(failureArray)) return [];
    const newFailureArray: FailureTableRow[] = [];
    failureArray.forEach((element, index) => {
      let newReasons = '';
      const reasons = element?.reasons;
      if (isValidArray(reasons)) {
        reasons.forEach(reason => {
          newReasons += (reason?.message || '') + ',';
        });
        newReasons = newReasons.slice(0, newReasons.length - 1);
      }
      newFailureArray.push({
        objectId: element?.objectId ?? '-',
        reasons: newReasons || '-',
        row_number: element?.row_number ?? index,
      });
    });
    return newFailureArray;
  }

  generateColumnForTable = () => {
    const { classes, failureArray, airlineList, id } = this.props;
    const columnData: any = [{
      title: 'Container',
      dataIndex: 'objectId',
      key: 'objectId',
    },{
      title: 'Reason',
      dataIndex: 'reasons',
      key: 'reasons',
    }];
    return columnData;
  }

  handleModalClose = () => {
    this.props.onModalClose();
  }

  handleModalOk = () => {
    this.props.onModalClose();
  }

  render() {
    const { classes, failureArray, isVisible, isCancelAbsent, okText } = this.props;
    return (
      <Modal title="Errors" visible={isVisible} width={1200} okText="Ok"
        destroyOnClose
        onCancel={this.handleModalClose}
        footer={<React.Fragment>
          {isCancelAbsent ? null : <Button onClick={this.handleModalClose}>Cancel</Button>}
          <Button type="primary" onClick={this.handleModalOk}>
            {okText ? okText : 'OK'}
          </Button>
        </React.Fragment>}>
        <div>
          <Table
            pagination={false}
            scroll={{ x: this.state.columnNameForTable.length * 150 }}
            columns={this.state.columnNameForTable}
            dataSource={this.modifyFailureArray(failureArray)}
            rowKey={(record: FailureTableRow, index: number) => String(record.row_number ?? index)}
          >
          </Table>
        </div>

      </Modal>
    );
  }
}

const StyledComp = injectSheet(styles)(BulkTrackingErrorModal);
export default StyledComp;
